import { InstancesData } from '../types/api'
import { InstanceCard } from './InstanceCard'
import { colors, spacing, borderRadius } from '../styles/tokens'

interface InstancesListProps {
  data: InstancesData | null
}

export function InstancesList({ data }: InstancesListProps) {
  if (!data) return <div></div>

  if (data.length === 0) {
    return (
      <div style={{
        backgroundColor: colors.background.card,
        border: `1px solid ${colors.border.main}`,
        borderRadius: borderRadius.lg,
        padding: spacing['2xl'],
        textAlign: 'center',
        color: colors.text.muted
      }}>
        <pre>No instances available</pre>
      </div>
    )
  }
  
  return (
    <div style={{ 
      display: 'flex',
      flexDirection: 'column',
      gap: spacing.lg,
      marginTop: spacing.lg
    }}>
      {data.map((instance, index) => (
        <InstanceCard 
          key={instance.Instance || index} 
          instance={instance} 
          index={index}
        />
      ))}
    </div>
  )
}
